import { render, staticRenderFns } from "./CourseProjectAdmin.vue?vue&type=template&id=b8e923fa&scoped=true&"
import script from "./CourseProjectAdmin.vue?vue&type=script&lang=js&"
export * from "./CourseProjectAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e923fa",
  null
  
)

export default component.exports